import { useQuery } from "@apollo/client/react";
import type { InvoiceAssessmentModel } from "../../../models/InvoiceAssessment";
import GET_INVOICE_ASSESSMENT_DETAILS from "../../queries/invoices/getInvoiceAssessmentDetails";

export const useInvoiceAssessmentDetails = (
  clientIdentifier?: string,
  invoiceId?: string,
) => {
  const { data, error, loading, refetch } = useQuery<{
    invoice: InvoiceAssessmentModel;
  }>(GET_INVOICE_ASSESSMENT_DETAILS, {
    variables: {
      clientIdentifier: clientIdentifier,
      invoiceId: invoiceId,
    },
    errorPolicy: "all",
    skip: !clientIdentifier || !invoiceId,
  });
  return { invoice: data?.invoice, error, loading, refetch };
};
